import { useContext } from "react"

import { LanguageContext, defaultLocale } from "@/utils/language-provider"
import { LangStrings } from "./lang-strings"

const AVAILABLE_LANGS = ["fr", "en"]

export default () => {
	const [locale, country] = useContext(LanguageContext)

	const t = (key: string, params?: Record<string, string | number>): string => {
		const strings = LangStrings[locale]
		const fallback = LangStrings[defaultLocale]
		let resolved: string
		if (params && "count" in params && typeof params.count === "number") {
			// CLDR: French uses singular for 0 and 1, English only for 1
			const isOne = locale === "fr" ? params.count >= 0 && params.count < 2 : params.count === 1
			const suffix = isOne ? "_one" : "_other"
			resolved = strings[key + suffix] || fallback[key + suffix] || strings[key] || fallback[key] || key
		} else {
			resolved = strings[key] || fallback[key] || key
		}
		return params
			? resolved.replace(/\{\{(\w+)\}\}/g, (_, k) => (params[k] !== undefined ? String(params[k]) : `{{${k}}}`))
			: resolved
	}

	const setLocale = (lang: string) => {
		localStorage.setItem("locale", lang)
		window.location.reload()
	}

	return { t, locale, country, setLocale, availableLangs: AVAILABLE_LANGS }
}
